import fb from '../firebase'

class FirebasePresence {
  uid = null
  castId = null
  sessionId = null

  constructor (config) {
    this.uid = config.uid
    this.castId = config.castId
    this.sessionId = config.sessionId

    // setup our connection
    try {
      this.setupPresence()
    } catch (error) {
      console.error(error)
      setTimeout(() => this.setupPresence(), 4000)
    }
  }

  setupPresence () {
    this.userStatusFirestoreRef = fb.firebase.firestore().doc('/session/' + this.sessionId)
    this.userStatusDatabaseRef = fb.firebase.database().ref('/sessions/' + this.sessionId)
    fb.firebase.auth().onAuthStateChanged(user => {
      if (user) {
        const isOfflineForDatabase = {
          uid: this.uid,
          castid: this.castId,
          state: 'offline',
          last_changed: fb.firebase.database.ServerValue.TIMESTAMP
        }
        //
        const isOnlineForDatabase = {
          uid: this.uid,
          castid: this.castId,
          state: 'online',
          last_changed: fb.firebase.database.ServerValue.TIMESTAMP
        }
        // Create a reference to the special '.info/connected' path in
        // Realtime Database. This path returns `true` when connected
        // and `false` when disconnected.
        fb.firebase.database().ref('.info/connected').on('value', snapshot => {
          // If we're not currently connected, don't do anything.
          if (snapshot.val() === false) {
            return
          }

          // If we are currently connected, then use the 'onDisconnect()'
          // method to add a set which will only trigger once this
          // client has disconnected by closing the app,
          // losing internet, or any other means.
          this.userStatusDatabaseRef.onDisconnect().set(isOfflineForDatabase).then(() => {
            // The promise returned from .onDisconnect().set() will
            // resolve as soon as the server acknowledges the onDisconnect()
            // request, NOT once we've actually disconnected:
            // https://fb.google.com/docs/reference/js/fb.database.OnDisconnect

            // We can now safely set ourselves as 'online' knowing that the
            // server will mark us as offline once we lose connection.
            this.userStatusDatabaseRef.set(isOnlineForDatabase)
          }).catch(error => {
            console.error('On Disconnect Error', error)
          })
        })

        // already part of the settings
        // const settings = { timestampsInSnapshots: true }
        // fb.firestore().settings(settings)

        // Firestore uses a different server timestamp value, so we'll
        // create two more constants for Firestore state.
        const isOfflineForFirestore = {
          state: 'offline',
          last_changed: fb.firebase.firestore.FieldValue.serverTimestamp()
        }

        const isOnlineForFirestore = {
          state: 'online',
          last_changed: fb.firebase.firestore.FieldValue.serverTimestamp()
        }

        fb.firebase.database().ref('.info/connected').on('value', snapshot => {
          if (snapshot.val() === false) {
            // Instead of simply returning, we'll also set Firestore's state
            // to 'offline'. This ensures that our Firestore cache is aware
            // of the switch to 'offline.'
            this.userStatusFirestoreRef.set(isOfflineForFirestore)
            return
          }

          this.userStatusDatabaseRef.onDisconnect().set(isOfflineForDatabase).then(() => {
            this.userStatusDatabaseRef.set(isOnlineForDatabase)

            // We'll also add Firestore set here for when we come online.
            this.userStatusFirestoreRef.set(isOnlineForFirestore)
          }).catch(error => {
            console.error('On disconnect error', error)
          })
        })
      } else {
        // User is signed out.
        console.log('signed out: ' + user)
      }
    })
  }

  closeCast () {
    const isLoggedIn = fb.firebase.auth().currentUser !== null
    if (!isLoggedIn) {
      console.log('Did not close presence as the user is no longer logged in')
      return
    }

    const isOfflineForFirestore = {
      state: 'offline',
      last_changed: fb.firebase.firestore.FieldValue.serverTimestamp()
    }
    this.userStatusFirestoreRef.set(isOfflineForFirestore).catch(error => {
      console.error('Error in closeCast ', error)
    })
    
    const isOfflineForDatabase = {
      uid: this.uid,
      castid: this.castId,
      state: 'offline',
      last_changed: fb.firebase.database.ServerValue.TIMESTAMP
    }
    this.userStatusDatabaseRef.set(isOfflineForDatabase).catch(error => {
      console.error('Error in closeCast ', error)
    })
  }
}

//
export default FirebasePresence
